import { Component, OnInit, OnDestroy, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Subject } from 'rxjs';

import { HelperService } from '@app/core/services/helper.service';
import { HasRequiredField } from '@app/ui-forms/classes/has-required-field';

interface IDate {
	date: string;
	shortDate: string;
	weekDay: string;
}

@Component({
	selector: 'ui-radio-button-control',
	templateUrl: './radio-button-control.component.html',
	styleUrls: ['../../styles/form-controls.less', './radio-button-control.component.less'],
})
export class RadioButtonControlComponent implements OnInit, OnDestroy {
	@Input() form: FormGroup;
	@Input() form_control: FormControl;
	@Input() label: string = null;
	@Input() info: string = null;
	@Input() input_css_class: string = '';
	@Input() disabled: boolean = false;
	@Input() show_error_text: boolean = true;
	@Input() highlighted_info: boolean = false;
	@Input() options: { value: number | string; name: string; description?: string }[];
	@Input() show_validation_icon = false;

	@Output() changed: EventEmitter<IDate> = new EventEmitter<IDate>();

	form_control_id: string = '';
	form_control_name: string = '';

	private destroyed$: Subject<any> = new Subject();

	constructor(private helper_service: HelperService) {}

	ngOnInit(): void {
		let form_control_name = null;
		const parent = this.form_control.parent;

		if (parent instanceof FormGroup) {
			Object.keys(parent.controls).forEach((name) => {
				if (this.form_control === parent.controls[name]) {
					form_control_name = name;
				}
			});
		}

		this.form_control_name = form_control_name;
		this.form_control_id = 'radio_button_' + this.helper_service.generateRandomString(30);
	}

	onSelectOption(id): void {
		this.form_control.setValue(id);
		this.form_control.markAsDirty();
		this.changed.emit(id);
	}

	isInvalid(): boolean {
		return (this.form_control.dirty || this.form_control.touched) && this.form_control.invalid;
	}

	/**
	 * Checks if control passes validation.
	 *
	 * @returns {boolean}
	 */
	isValid(): boolean {
		return this.form_control.valid && this.form_control.value;
	}

	isRequired(): boolean {
		return HasRequiredField(this.form_control);
	}

	getError(): string {
		if (this.isInvalid() && this.show_error_text) {
			if (this.form_control.hasError('required')) {
				return 'is required';
			}

			if (this.form_control.hasError('isBlank')) {
				return 'is blank';
			}

			return 'is invalid';
		}
	}

	getRequired(): string {
		if (!this.getError()) {
			return HasRequiredField(this.form_control) ? ' *' : '';
		}
	}

	ngOnDestroy() {
		this.destroyed$.next();
	}
}
